import React, { useEffect } from "react";

interface Props {
  index: number;
  curr: number;
  durr: number;
  src: string;
  nextSlide: any;
}

const ImageSlide: React.FC<Props> = ({ index, curr, src, durr, nextSlide }) => {
  return (
    <>
      <div className="image" style={{ backgroundImage: `url(${src})` }}></div>
    </>
  );
};
export default ImageSlide;
